import { makeSelectors, combineTokens } from '@utils/css';

const tokens = combineTokens("--print-page", {
  columnGap: "30px",
  paddingTop: "0px",
  paddingBottom: "0"
});
const templateContainer = "_7ct1dryuwz";
const page = "_7cpwocfrp";
const paddingTop = "_7cpxumb2m";
const paddingBottom = "_7cp1t1cugg";
const pageContent = "_7cpw9wkiq";
const chunk = "_7cci9ytxz";
const column = "_7cc1dpt5th";
const content = "_7cc1kn5j3k";
const footer = "_7cf1rtd7xn";
const pageSelectors = makeSelectors({
  page,
  pageContent,
  chunkContainer: "chunk--container",
  chunk,
  column,
  content,
  paddingTop,
  paddingBottom,
  header: "page--header",
  footer
});

export { chunk, column, content, footer, paddingBottom, paddingTop, page, pageContent, pageSelectors, templateContainer, tokens };
import "./comp.page.style.linaria.module.css";
//# sourceMappingURL=comp.page.style.js.map
